import { render } from "./ShowUserComponent.vue?vue&type=template&id=764f9692&scoped=true"
import script from "./ShowUserComponent.vue?vue&type=script&lang=js"
export * from "./ShowUserComponent.vue?vue&type=script&lang=js"

import "./ShowUserComponent.vue?vue&type=style&index=0&id=764f9692&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-764f9692"

export default script